import { Checkbox, Text, Thumbnail } from '@wix/design-system';
import React from 'react';
import styles from './SelectionCard.scss';
export const SelectionCard = _ref => {
  let {
    title,
    description,
    icon,
    onClick,
    isSelected,
    selectionType = 'single'
  } = _ref;
  return /*#__PURE__*/React.createElement(Thumbnail, {
    onClick: onClick,
    selected: isSelected,
    hideSelectedIcon: selectionType === 'multiple'
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.selectionCard
  }, selectionType === 'multiple' && /*#__PURE__*/React.createElement("div", {
    className: styles.selectionCardHead
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: isSelected
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.selectionCardContent
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "normal"
  }, title), description && /*#__PURE__*/React.createElement(Text, {
    secondary: true,
    size: "small"
  }, description)), /*#__PURE__*/React.createElement("div", {
    className: styles.selectionCardTail
  }, icon)));
};
//# sourceMappingURL=SelectionCard.js.map